import React from "react";
import "./CustomerReviews.css";

const CustomerReviews = ({ reviews }) => {
  if (!reviews) return null;

  return (
    <div className="cr-container" id="reviews">
      <div className="cr-header">
        <h2>Customer Reviews ({reviews.totalReviews}+)</h2>
        <a href="view-all-link" className="view-all-link">View All &gt;</a>
      </div>

      <div className="cr-summary-block">
        <div className="cr-score-section">
          <div className="score">{reviews.averageRating}</div>
          <div className="stars">★★★★★</div>
          <div className="review-policy">Review Policy</div>
        </div>

        <div className="cr-fit-section">
          <div className="fit-title">Overall Fit:</div>
          <div className="fit-bar-container">
            <div className="fit-label">Small</div>
            <div className="fit-bar"><div className="fill" style={{ width: '5%' }}></div></div>
            <div className="fit-label">5%</div>
            
            <div className="fit-label">True to Size</div>
            <div className="fit-bar active"><div className="fill" style={{ width: '91%' }}></div></div>
            <div className="fit-label">91%</div>
            
            <div className="fit-label">Large</div>
            <div className="fit-bar"><div className="fill" style={{ width: '4%' }}></div></div>
            <div className="fit-label">4%</div>
          </div>
        </div>
      </div>

      <div className="cr-tags">
        {reviews.fitTags?.map((tag, idx) => (
          <span key={idx} className="cr-tag">
            {tag.label} ({tag.count}+)
          </span>
        ))}
      </div>

      <div className="cr-list">
        {reviews.items?.slice(0, 1).map((review) => (
          <div key={review.id} className="cr-item">
            <div className="cr-user-info">
              <strong>{review.name.charAt(0)}***{review.name.charAt(review.name.length - 1)}</strong>
              <span className="cr-date">{review.date}</span>
            </div>
            <div className="cr-stars">★★★★★</div>
            
            {/* Added details mock */}
            <div className="cr-attributes">
              Height: 169 cm / 67 in &nbsp; Weight: 69 kg / 152 lbs &nbsp; Size: S
            </div>
            
            <p className="cr-text">{review.text}</p>
            
            {review.image && (
              <div className="cr-images">
                <img src={review.image} alt="Review" />
              </div>
            )}
            
            <div className="cr-actions">
              <span className="helpful">👍 Helpful ({review.helpfulCount})</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerReviews;
